import * as React from 'react'

const SvgCaretRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.125 5.625l5 4.375-5 4.375v-8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCaretRightIcon
